var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../api/axios";
export const RootLoader = (skuParam) => __awaiter(void 0, void 0, void 0, function* () {
    const sku = skuParam.params.sku;
    try {
        const [registerFormDataRes, generalSettingsRes, accountSettingsRes] = yield Promise.all([
            axiosPrivate.get("/GetRegisterFormData"),
            axiosPrivate.post(`/React/GetGeneralConfigurations?sku=${sku}`),
            axiosPrivate.get(`/Account/AccountSettings`),
        ]);
        const { data: accountSettings } = accountSettingsRes;
        const { data: { referrals, privacyPolicyBannerText, privacyPolicyUrl, shouldShowPrivacyPolicy }, } = registerFormDataRes;
        const { data: { generalSettings }, } = generalSettingsRes;
        return {
            referrals,
            privacyPolicyBannerText,
            privacyPolicyUrl,
            shouldShowPrivacyPolicy,
            generalSettings,
            accountSettings,
        };
    }
    catch (err) {
        console.error(err);
    }
});
